module.exports = __webpack_public_path__ + "static/media/CONSTRUCTION 2.c6a97f82.jpg";